import {Component, HostListener, inject, OnInit, ViewEncapsulation} from "@angular/core";
import {WINDOW} from "@kwsoft/otcx-core";

const TABLET_BREAKPOINT = 768;

@Component({
    selector: "otcx-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HomeComponent implements OnInit {

    isMobile: boolean;
    private readonly window = inject(WINDOW);

    ngOnInit(): void {
        this.isMobile = this.isMobileBreakpoint(this.window);
    }

    @HostListener("window:resize", ["$event"])
    onResize(event): void {
        this.isMobile = this.isMobileBreakpoint(event.target);
    }

    private isMobileBreakpoint(window: Window): boolean {
        return window.innerWidth < TABLET_BREAKPOINT;
    }
}
